import React, { useState, useEffect, useContext } from 'react';
import { api } from '../api';
import { fetchToken, fetchRole } from '../auth/Token';
import { Box, Button, IconButton,Typography, TextField , Avatar, CircularProgress, Select, Grid, Fab, Chip } from "@mui/material";
import { DataGrid, GridToolbar, GridRowParams, GridActionsCellItem} from '@mui/x-data-grid';
import RecommendIcon from '@mui/icons-material/Recommend';
import Snackbar from '@mui/material/Snackbar';
import AuthContext from "../auth/AuthProvider";
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from 'react-router-dom';
import MoreIcon from '@mui/icons-material/More';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';
import DialogTitle from '@mui/material/DialogTitle';
import { PDFViewer, Font,PDFDownloadLink } from "@react-pdf/renderer";
import SendIcon from '@mui/icons-material/Send';
import Slide from '@mui/material/Slide';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
// import ReactDOM from 'react-dom/client';
import KPeeLogo from '../LogoKPee1.png';
import { decode } from "base-64";
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import CancelIcon from '@mui/icons-material/Cancel';
import { ShareCert } from './SharesDetails';
import { toast } from 'sonner';



const FormatedDate = ({value}) => {
  const timestamp = value;
  const date = new Date(timestamp);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours() % 12 || 12).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const amOrPm = date.getHours() >= 12 ? 'PM' : 'AM';

  const formattedDate = `${year}-${month}-${day} ${hours}:${minutes} ${amOrPm}`;
  return <span>{formattedDate}</span>;
}

const FormatedDateWithTime = ({value}) => {
  const timestamp = value;
  const date = new Date(timestamp);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours() % 12 || 12).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const amOrPm = date.getHours() >= 12 ? 'PM' : 'AM';

  const formattedDate = `${year}-${month}-${day} ${hours}:${minutes} ${amOrPm}`;
  return <Text>{formattedDate}</Text>;
}

const FormatedDateNoTime = ({value}) => {
  const timestamp = value;
  const date = new Date(timestamp);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  const formattedDate = `${year}-${month}-${day}`;
  return <Text>{formattedDate}</Text>;
}

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});


const AssociationShareInfo = (props) => {
  const [opennn, setOpennn] = React.useState();
  const navigate = useNavigate();
  const {  permissions } = useContext(AuthContext);
  const [start_date, setStart_date] = useState('')
  const [end_date, setEnd_date] = useState('')
  const [shares, setShares] = useState('')
  const [amount_sum, setAmount_sum] = useState()
  const [total_interest_sum, setTotal_interest_sum] = useState()

 
  const fetch_association_shares = () => {
    const data = new FormData()
    data.append('association_id', props.id)
    data.append('start_date', start_date)
    data.append('end_date', end_date)

    api.post('/association/shares/info', data, {
        headers: {
          Authorization: 'Bearer '+ fetchToken()
        },
      }).then(function (response){
        setShares(response.data?.results);
        setAmount_sum(response.data?.total_amount);
        setTotal_interest_sum(response.data?.total_interest)
      }).catch(function (error){
        console.log(error)
      })
  }

  const fetch_again = () => {
    setStart_date('')
    setEnd_date('')
    fetch_association_shares()
  }


  useEffect(() => {
    fetch_association_shares()
  }, [])


  const columns = [
    {
        field: "Transaction_id",
        headerName: "Id",
        flex:1,
        width: 70,
    },
    {
      field: "Member_name",
      headerName: "Member name",
      flex:1,
      width: 70,
    },
    {
        field: "Transaction_date",
        headerName: 'DateTime',
        flex: 1,
        cellClassName: "name-column--cell",
        renderCell:(params) => <FormatedDate value={params.row.Transaction_date}/>
    },
    {
        field: "Amount",
        headerName: "Amount(GH₵)",
        flex:1,
        width: 70,
    },
    {
        field: "Prepared_by",
        headerName: "Prepared by",
        flex:1,
        width: 70,
    },
    {
        field: "Narration",
        headerName: "Narration",
        flex:1,
        width: 70,
    },
    {
      field: "Period",
      headerName: "Period",
      flex:1,
      width: 70,
    },
    {
      field: "Total_Interest",
      headerName: "Total Interest(GHS)",
      flex:1,
      width: 70,
    },
    // {
    //     field: "Weeks_Left",
    //     headerName: "Weeks Left",
    //     flex:1,
    //     width: 70,
    //   },
    {
      field: "Member_id",
      headerName: "Member id",
      flex:1,
      width: 70,
    },
    {
      field: "action",
      type: 'actions',
      headerName: "Share Certificate",
      flex:1,
      width: 70,
      getActions: (params: GridRowParams) => [
        <GridActionsCellItem
        icon={<VisibilityOutlinedIcon />}
        onClick={() => shareAdvise(params.row.Transaction_id)} 
        label="Open"
      />]
    },
    {
      field: 'actions',
      type: 'actions',
      headerName: "Member Detail",
     getActions: (params: GridRowParams) => [
        <GridActionsCellItem
        icon={<MoreIcon />}
        onClick={() => handlePsb(params)} 
        label="Open"
      />]
    }
  ]

  const handlePsb = (params) => {
    navigate('/onemember/', {state: {
      Member_id: params.row.Member_id,
      Fullname: `${params.row.Member_name}`,
    } })
  };

  const shareAdvise = async (id) => {
    if(permissions && permissions.download_share_cert === true){
        await api.get(`/transactions/share/slip/${id}`, {
          headers: {
            Authorization: 'Bearer '+ fetchToken()
          },
        }).then(function (response){
            setOpennn(<ShareCert Basic_Info={response.data?.Basic_Info} Transaction_Details={response.data?.Transaction_Details} setOpennn={setOpennn} />)
        }).catch(function (error){
          console.log(error);
        });
      }else{
        toast.warning("Not Authorized")
      }
  }

  const CustomFooterRow = () => {
    return (
      <div>
        <div style={{ display: 'flex', padding: '4px' }}>
          <Typography variant="h5" sx={{ color:'red', mr:4 }}>Total:</Typography>
          <Typography variant="h5" sx={{ color:'darkblue', mr:4 }}>Amount: {amount_sum} </Typography>
          <Typography variant="h5" sx={{ color:'darkblue', mr:4 }}>Interest: {total_interest_sum} </Typography>
         </div>
      </div>
    );
  };


  return (
    <div>
        <Box
          m="40px 0 0 0"
          height="75vh"
          paddingBottom="85px"
      >
          <Typography variant='h3' sx={{ marginBottom:'10px' }}>Savings Group's Shares and Holders</Typography>
        <Typography>Filter Date</Typography>
            <div style={{ display:'flex' }}>
              <TextField
                type='date'
                size="small"
                required
                variant="outlined"
                helperText="From"
                name="start_date"
                onChange={(e) => setStart_date(e.target.value)}
                value={start_date}
                sx={{ mr:1 }}
              />

              <TextField
                type='date'
                size="small"
                required
                variant="outlined"
                helperText="To"
                name="end_date"
                onChange={(e) => setEnd_date(e.target.value)}
                value={end_date}
                sx={{ mr:1 }}
              />

              <IconButton onClick={fetch_association_shares}><FilterAltOutlinedIcon /></IconButton>
              <IconButton onClick={fetch_again}><CancelIcon /></IconButton>
              
            </div>
      <DataGrid
          rows={shares}
          columns={columns}
          checkboxSelection
          getRowId={(row) => row.Transaction_id}
          slots={{ toolbar: GridToolbar, footer: CustomFooterRow }}
          initialState={{
            columns: {
              columnVisibilityModel: {
                Transaction_id: false,
                Member_id: false,
              },
            },
          }}
      />
      </Box>
      {opennn}
    </div>
  )
}

export default AssociationShareInfo